import Service from "../../../../utils/api/service";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import _debounce from "lodash.debounce";
export default {
  name: "EditProductDiscount",
  data() {
    return {
      isUpdating: false,
      freeShipping: true,
      loading: {
        isProductSearching: false,
        isVariantSearching: false,
        customerLoading: false,
        categoryLoading: false,
        customerGroupLoading: false,
      },
      isLoading: true,
      body: {
        name: "",
        discountType: "percentage",
        discountValue: 0,
        categoryIds: [],
        productId: [],
        variantIds: [],
        customerGroupIds: [],
        customerIds: [],
        customerGroupAction: "include", // include | exclude
        startDate: this.$moment().startOf("day").toDate(),
        endDate: this.$moment().endOf("day").toDate(),
        status: "active", // active | inactive
        customerAction: "include", // include | exclude
        isCombineBP: false, // true | false
        description: "",
      },
      data: {
        productList: [],
        categories: [],
        customers: [],
        customerGroups: [],
        variants: [],
      },
      display: {
        category: false,
      },
      model: {
        products: [],
        variants: [],
        categories: [],
        customers: [],
        customerGroups: [],
      },
      showTimePanel: false,
      showTimeRangePanel: false,
      actions: [
        { id: "include", name: "Include" },
        { id: "exclude", name: "Exclude" },
      ],
      discountTypes: [
        { id: "fix_amount", name: "Fixed Amount" },
        { id: "percentage", name: "Percentage" },
      ],
    };
  },
  components: { Multiselect, DatePicker },
  computed: {
    debouncedOnSearchProducts() {
      return _debounce(this.searchProducts, 500);
    },
    debouncedOnSearchVariants() {
      return _debounce(this.searchVariants, 500);
    },
    debouncedOnGetCustomers() {
      return _debounce(this.getCustomers, 500);
    },
  },
  created() {
    this.getDetail(this.$route.query.id);
  },
  methods: {
    /***
     * @apply to check auto remove
     * - product by category id
     * - variant by product id
     * - customer by customer group id
     */
    onInputUpdateCategoryId() {
      const categoryIds = this.model.categories.map((cat) => cat?.id);

      // Keep only products that belong to valid categories
      this.model.products = this.model.products.filter((product) => {
        const categoryId = product?.category?.id; // match product's category.id
        return categoryIds.includes(categoryId);
      });

      this.onInputUpdateProductId();
    },

    onInputUpdateProductId() {
      const productIds = this.model.products.map((prod) => prod.id);

      // Keep only variants that belong to valid products
      this.model.variants = this.model.variants.filter((variant) => {
        return productIds.includes(variant?.productId);
      });
    },

    onInputUpdateCustomerGroupId() {
      const groupIds = this.model.customerGroups.map((group) => group.id);

      // Keep only customers that belong to valid customer groups
      this.model.customers = this.model.customers.filter((customer) => {
        return groupIds.includes(customer?.customerGroupId);
      });
    },

    goBack() {
      this.$router.push({
        name: "ListProductDiscount",
        query: {
          page: 1,
          limit: 10,
        },
      });
    },

    getDetail(id) {
      this.isLoading = true;

      Service.getProductDiscountDetail(id).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getDetail(id);
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.data.detail = response.data;
          // convert date
          let convertstartDate = moment(
            this.reNewTimestamp(this.data.detail.startDate)
          ).toDate();
          let convertendDate = moment(
            this.reNewTimestamp(this.data.detail.endDate)
          ).toDate();
          this.data.detail.startDate = convertstartDate;
          this.data.detail.endDate = convertendDate;

          //map category
          this.data.detail.categoryIds = [];
          this.body.status = response?.data?.status;

          if (this.data.detail.categories.length > 0) {
            for (let i = 0; i < this.data.detail.categories.length; i++) {
              const element = this.data.detail.categories[i];
              this.model.categories.push(element);
            }
          }

          //map product
          this.model.products = [];
          if (this.data.detail.products.length > 0) {
            for (let i = 0; i < this.data.detail.products.length; i++) {
              const element = this.data.detail.products[i];
              this.model.products.push(element);
            }
          }

          //map customer
          this.model.customers = [];
          if (this.data.detail.customers.length > 0) {
            for (let i = 0; i < this.data.detail.customers.length; i++) {
              const element = {
                ...this.data.detail.customers[i],
                fullName:
                  (this.data.detail.customers[i]?.bpName
                    ? this.data.detail.customers[i]?.bpName
                    : this.data.detail.customers[i]?.firstName +
                      " " +
                      this.data.detail.customers[i]?.lastName) +
                  " " +
                  "(" +
                  this.data.detail.customers[i]?.code +
                  ")",
              };
              this.model.customers.push(element);
            }
          }

          // map customer group
          this.model.customerGroups = [];
          if (this.data.detail.customerGroups.length > 0) {
            for (let i = 0; i < this.data.detail.customerGroups.length; i++) {
              const element = this.data.detail.customerGroups[i];
              this.model.customerGroups.push(element);
            }
          }

          /***
           * @set new field
           * - map variants
           */
          this.model.variants = [];
          if (this.data.detail.variants.length > 0) {
            for (let i = 0; i < this.data.detail.variants.length; i++) {
              const element = this.data.detail.variants[i];
              this.model.variants.push(element);
            }
          }
          this.body.customerGroupAction = this.data.detail.customerGroupAction;
          this.body.customerAction = this.data.detail.customerAction;
          this.body.isCombineBP = this.data.detail.isCombineBP;

          // get important option
          this.getCategory();
          // this.searchProducts();
          // this.getCustomers();
          this.getCustomerGroups();
          this.isLoading = false;
        }
      });
    },

    reNewTimestamp: function (timestamp) {
      const date = new Date(timestamp);
      date.setUTCHours(date.getUTCHours() - 7); // Subtract 7 hours
      const newTimestamp = date.toISOString();

      return newTimestamp;
    },

    getCategory() {
      Service.getAllCategories("").then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getCategory();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.data.categories = response.data;
        }
      });
    },

    getCustomers(query) {
      let param =
        typeof query === "string" && query
          ? "?status=active&search=" + query
          : "?status=active";
      if (this.model.customerGroups && this.model.customerGroups.length) {
        param += this.model.customerGroups
          .map((item) => `&customerGroupIds=${item.id}`)
          .join("&");
      }
      this.loading.customerLoading = true;

      Service.getCustomers(param).then((response) => {
        this.loading.customerLoading = false;

        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getCustomers();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          let customers = response.data;
          let newList = [
            {
              name: "Select All",
              list: customers.map((item) => {
                return {
                  ...item,
                  fullName:
                    (item?.bpName
                      ? item?.bpName
                      : item?.firstName + " " + item?.lastName) +
                    " " +
                    "(" +
                    item?.code +
                    ")",
                };
              }),
            },
          ];

          this.data.customers = newList;
        }
      });
    },

    getCustomerGroups() {
      let params = "?limit=150&offset=0";

      Service.getCustomerGroups(params).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getCustomerGroups();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.data.customerGroups = response.data;
        }
      });
    },

    showCheckboxes() {
      if (this.display.category) {
        this.display.category = false;
      } else {
        this.display.category = true;
      }
    },

    searchProducts(query) {
      let param =
        typeof query === "string" && query
          ? `?search=${query}&isOptionalPrice=true`
          : "?isOptionalPrice=true";

      if (this.model.categories && this.model.categories.length) {
        param += this.model.categories
          .map((item) => `&categoryIds=${item.id}`)
          .join("&");
      }
      this.loading.isProductSearching = true;

      Service.getAllProducts(param).then((response) => {
        this.loading.isProductSearching = false;

        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.searchProducts();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          let productList = response.data;
          let newList = [
            {
              name: "Select All",
              list: productList,
            },
          ];
          this.data.productList = newList;
        }
      });
    },

    searchVariants(query) {
      let param =
        typeof query === "string" && query
          ? `?search=${query}&isOptionalPrice=true`
          : "?isOptionalPrice=true";

      if (this.model.products && this.model.products.length) {
        param += this.model.products
          .map((item) => `&productIds=${item.id}`)
          .join("&");
      }
      this.loading.isVariantSearching = true;

      Service.getAllProductVariants(param).then((response) => {
        this.loading.isVariantSearching = false;

        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.searchVariants();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          let variants = response.data;
          let newList = [
            {
              name: "Select All",
              list: variants,
            },
          ];

          this.data.variants = newList;
        }
      });
    },

    onUpdate() {
      let validatedMessage = this.validateBody(this.data.detail);
      if (validatedMessage == "ok") {
        this.isUpdating = true;
        this.onSubmitUpdate();
      } else {
        this.$toasted.show(validatedMessage);
      }
    },

    validateBody(body) {
      if (!body.name) {
        return "Discount Name cannot be empty!";
      } else if (!body.discountType) {
        return "Type group cannot be empty!";
      } else if (
        typeof body.discountValue === "string" ||
        body.discountValue <= 0
      ) {
        return "Discount Value cannot be empty, it must be bigger than zero!";
      } else if (!this.model.categories.length) {
        return "Product Category cannot be empty!";
      } else if (!this.model.customerGroups.length) {
        return "Customer Group cannot be empty!";
      } else if (!body.startDate) {
        return "Start date/time cannot be empty!";
      } else if (!body.endDate) {
        return "End date/time cannot be empty!";
      } else if (!body.status) {
        return "Status order cannot be empty!";
      } else {
        return "ok";
      }
    },

    updateTimestamp: function (timestamp) {
      const iso = timestamp.toISOString();
      const date = new Date(iso);
      date.setUTCHours(date.getUTCHours() + 7); // Subtract 7 hours
      const newTimestamp = date.toISOString();

      return newTimestamp;
    },

    onSubmitUpdate() {
      this.data.detail.productIds = [];
      if (this.model.products) {
        for (let index = 0; index < this.model.products.length; index++) {
          const product = this.model.products[index];
          this.data.detail.productIds.push(product.id);
        }
      }

      this.body.customerGroupIds = [];
      if (this.model.customerGroups) {
        for (let index = 0; index < this.model.customerGroups.length; index++) {
          const customerGroup = this.model.customerGroups[index];
          this.body.customerGroupIds.push(customerGroup.id);
        }
      }

      this.body.customerIds = [];
      if (this.model.customers) {
        for (let index = 0; index < this.model.customers.length; index++) {
          const customer = this.model.customers[index];
          this.body.customerIds.push(customer.id);
        }
      }

      this.data.detail.categoryIds = [];
      if (this.model.categories) {
        for (let index = 0; index < this.model.categories.length; index++) {
          const product = this.model.categories[index];
          this.data.detail.categoryIds.push(product.id);
        }
      }

      this.body.variantIds = [];
      if (this.model.variants) {
        for (let index = 0; index < this.model.variants.length; index++) {
          const variant = this.model.variants[index];
          this.body.variantIds.push(variant.id);
        }
      }

      let itemId = this.$route.query.id;

      /***
       * @no depend field
       * @apply new field name :
       * - variantIds
       * - isCombineBP
       * - combineProductDiscount
       * - customerGroupAction
       * - customerAction
       */
      let body = {
        name: this.data.detail.name,
        discountType: this.data.detail.discountType,
        discountValue: this.data.detail.discountValue,
        categoryIds: this.data.detail.categoryIds,
        productIds: this.data.detail.productIds,
        customerIds: this.body.customerIds,
        customerGroupIds: this.body.customerGroupIds,
        startDate: this.updateTimestamp(this.data.detail.startDate),
        endDate: this.updateTimestamp(this.data.detail.endDate),
        status: this.body.status,

        // new field
        customerGroupAction: this.body.customerGroupAction,
        customerAction: this.body.customerAction,
        variantIds: this.body.variantIds,
        isCombineBP: this.body.isCombineBP,
        description: this.data.detail.description,
      };

      Service.updateProductDiscount(itemId, body).then((response) => {
        this.isUpdating = false;

        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.onSubmitUpdate();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.$toasted.show("Product discount has been updated.");
          this.goBack();
        }
      });
    },

    toUpperCase(string) {
      return string.toUpperCase();
    },

    toCapitalLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
  },
};
